import React from 'react';
import PropTypes from 'prop-types';
import {Modal as ModalSemantic, Transition} from 'semantic-ui-react';
import {Box, Modal as MuiModal} from '@mui/material';
import {injectIntl} from 'react-intl';
import closeImg from '../../assets/images/icons/X.svg';
import './Modal.scss';
import styles from './Modal.module.scss';
import cls from "classnames";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '10px',
    maxHeight: '90%',
    overflowY: 'auto',
};
const Modal = props => {
    const {open, onClose, children, size, title, noPadding = false} = props;

    return (
        <MuiModal
            open={open}
            closeAfterTransition={true}
            onClose={onClose}>
            <Box sx={style}>
                <div
                    className={cls(styles.modal, {[styles.noPadding]: noPadding})}
                >
                    {children}
                </div>
                <closeImg className={styles.close} onClick={onClose}/>
            </Box>
        </MuiModal>
    )
};

Modal.propTypes = {
    children: PropTypes.node,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    size: PropTypes.string,
};

Modal.defaultProps = {
    children: '',
    size: 'tiny',
};

export default injectIntl(Modal);
